import { reactive } from 'vue';

export const criarOperador = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdoperador: 0,
        idequipamento: 0,
        idipprestador: 0,
        idequipamentosetor: 0,
        nmoperador: '',
        apelido_operador: '',
        endereco: '',
        nmendereco: 0,
        complemento: '',
        bairro: '',
        nmmunicipio: '',
        uf: '',
        cep: '',
        fone: '',
        email: '',
        cpf: '',
        cpfnros: '',
        login: '',
        senha: '',
        dtsenha: '',
        ativo: 'S',
        blterceirizado: 'N',
        bltroca_equipamento: 'N',
        cdperfil: 0,
        ckabreos: 'N',
        ckchecklist: 'N',
        cnh_numero: '',
        cnh_categoria: '',
        cnh_validade: '',
        idlogin: 0
    });
}